import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';
import { SvgIconComponent } from '@components/svg-icon/svg-icon.component';
import { getCompetitionPath } from '@core/helpers';
import { PosthogEvent, ProjectCode } from '@core/models';
import { PosthogService, ProjectDataService } from '@core/services';
import { Store } from '@ngxs/store';
import { SetOrderDiscount } from '@store/settings/settings.actions';
import { SettingsState } from '@store/settings/settings.state';

@Component({
  selector: 'app-order-discount-banner',
  templateUrl: './order-discount-banner.component.html',
  styleUrls: ['./order-discount-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, SvgIconComponent]
})
export class OrderDiscountBannerComponent implements OnInit {
  private store = inject(Store);
  private router = inject(Router);
  private projectDataService = inject(ProjectDataService);
  private projectCode!: ProjectCode;
  private posthogService = inject(PosthogService);

  ngOnInit() {
    this.projectCode = this.projectDataService.get('project');
  }

  claimDiscount() {
    this.posthogService.capture(
      PosthogEvent.OrderConfirmationInstantWinOfferClicked
    );
    const orderDiscount = this.store.selectSnapshot(
      SettingsState.orderDiscount
    );
    this.store.dispatch(
      new SetOrderDiscount({
        bannerVisible: false,
        slug: orderDiscount?.slug
      })
    );

    this.router.navigate([
      getCompetitionPath(this.projectCode, orderDiscount?.slug)
    ]);
  }

  closeBanner() {
    this.store.dispatch(new SetOrderDiscount(null));
  }
}
